import React, { useContext, useEffect, useState } from 'react'
import CountUp from 'react-countup';

import { AuthContext } from '../context/AuthContext';
export const ConteoSimpatizantes = () => {
    const {
        mostrarFiltros, 
        setMostrarFiltros, 
        mostrarDatosCapa,
        idMunicipioSeleccionado, 
        setIdMunicipioSeleccionado,
        URL} = useContext(AuthContext); 
    const [simpatizantes, setSimpatizantes] = useState(0);
    useEffect(() => {
        obtenerConteoMilitantes()    
    }, [idMunicipioSeleccionado])

    const obtenerConteoMilitantes = () => {
        setSimpatizantes(0);
        fetch(URL+'/simpatizantes.php?funcion=conteoSimpatizantesMunicipio2&idPoligono='+idMunicipioSeleccionado)
        .then(response => response.json())
        .then(data => {
            setSimpatizantes(data[0].Simpatizantes);
            console.log('Datos de conteo militantes', data);
        })

    }

  return (
    <div
        style={{
            margin:20,
            marginTop:30,
            backgroundColor:'white',
            opacity:.7,
            borderRadius:10,
            color:'black'
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'column',
                margin:10,
                fontSize:17
            }}
        >
            <span
                style={{
                    fontSize:17
                }}
            >Red Sinergia</span> 
            {
                <span
                    style={{fontSize:25}}
                >
                    <CountUp end={simpatizantes} />
                    
                </span>
            }
        </div>
    </div>
  )
}
